import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en.json";

const translationLoaders = {
  am: () => import("./locales/am.json").then((m) => m.default),
  om: () => import("./locales/om.json").then((m) => m.default),
  tg: () => import("./locales/tg.json").then((m) => m.default),
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
    },
    partialBundledLanguages: true,
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "caregiver-language",
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    // Override changeLanguage AFTER initialization is fully completed!
    const originalChangeLanguage = i18n.changeLanguage.bind(i18n);

    i18n.changeLanguage = async (lng) => {
      if (
        lng &&
        lng !== "en" &&
        translationLoaders[lng] &&
        !i18n.hasResourceBundle(lng, "translation")
      ) {
        try {
          const data = await translationLoaders[lng]();
          i18n.addResourceBundle(lng, "translation", data, true, true);
        } catch (err) {
          console.error(`Failed to load translation bundle for ${lng}:`, err);
        }
      }
      return originalChangeLanguage(lng);
    };

    // Load initial language if not English
    const lang = i18n.language;
    if (lang && lang !== "en" && translationLoaders[lang]) {
      translationLoaders[lang]().then((data) => {
        i18n.addResourceBundle(lang, "translation", data, true, true);
        originalChangeLanguage(lang); // Force rerender with loaded resources
      });
    }
  });

i18n.on("languageChanged", (lng) => {
  if (
    lng &&
    lng !== "en" &&
    translationLoaders[lng] &&
    !i18n.hasResourceBundle(lng, "translation")
  ) {
    translationLoaders[lng]().then((data) => {
      i18n.addResourceBundle(lng, "translation", data, true, true);
      i18n.changeLanguage(lng); // Force update safely
    });
  }
});

export default i18n;
